<template>
  <donut-slack-preview :hide-name="true" :message="message" />
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state } = useStore();

  const message = computed(() => `:crescent_moon: *You just earned a new badge!*\nNice work, :::${state.currentUser.mention_name}!::: You unlocked the `
        + `Night Owl badge *+ 1 :${state.pointsConfig.config.emoji}:* for your reward balance.`);
</script>
